import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="cta-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <h2 id="cta-title" className="font-heading text-2xl md:text-4xl font-extrabold text-foreground-950">
              即刻开启你的<strong>韩漫之旅</strong>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-md mx-auto">
              海量正版韩国漫画，免费在线阅读，高清画质，每日更新
            </p>
            <div className="mt-7">
              <Link
                to="/category/rexue"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                免费开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="mt-12 relative rounded-2xl overflow-hidden h-[200px] md:h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20colorful%20Korean%20manhwa%20character%20silhouettes%20in%20dynamic%20poses%20on%20clean%20white%20background%2C%20paper%20cutout%20style%2C%20warm%20peach%20and%20coral%20and%20cream%20color%20palette%2C%20playful%20composition%2C%20editorial%20design%2C%20minimal%20flat%20illustration%20style&width=1600&height=560&seq=cta-banner-2026&orientation=landscape"
              alt="韩漫阅读之旅 - 海量正版漫画等你来读"
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}